export default {
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			type: 'cross'
		},
		formatter(params) {
			let lines = [params[0] ? params[0].axisValue : ''];
			params.forEach(item => {
				let suffix = item.seriesName === '利润率' ? '%' : 'K';
				lines.push(`${item.seriesName} ${item.value}${suffix}`);
			});
			return lines.join('<br>');
		}
	},
	legend: {
		data: ['主营业务收入', '本年利润', '利润率']
	},
	grid: {
		left: '3%',
		right: '5%',
		bottom: '3%',
		containLabel: true
	},
	toolbox: {
		show: true,
		feature: {
			mark: {show: true},
			magicType: {show: true, type: ['line', 'bar']},
			restore: {show: true},
			saveAsImage: {show: true}
		}
	},
	calculable: true,
	xAxis: [
		{
			type: 'category',
			data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
		}
	],
	yAxis: [
		{
			type: 'value',
			axisLabel: {
				formatter: '{value} K'
			}
		},
		{
			type: 'value',
			axisLabel: {
				formatter: '{value}%'
			},
			splitLine: {
				show: false
			}
		}
	],
	series: [
		{
			name: '主营业务收入',
			type: 'bar',
			barMaxWidth: 22,
			data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
		},
		{
			name: '本年利润',
			type: 'bar',
			barMaxWidth: 22,
			data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
		},
		{
			name: '利润率',
			type: 'line',
			yAxisIndex: 1,
			smooth: true,
			connectNulls: false,
			symbol: 'circle',
			symbolSize: 8,
			data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
		}
	]
};
